import Route from '@ember/routing/route'
import { service } from '@ember/service'
import RSVP from 'rsvp'
import type { NormalizedInterval } from 'date-fns'
import type { StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export class CourseProgressRexSpellingRoute extends Route {
  @service studentEvents!: StudentEventsService

  async model() {
    const { uiScope, scopedData, period } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>

    const scopedStudents = scopedData.students
    const statsScope: StudentsScope = { scope: 'students', ids: scopedStudents.map((s) => s.id) }

    const product: LegacyProductRex = 'rex'
    const precinct: LegacyPrecinctSpelling = 'spelling'
    const stats = await this.makeStatsRequests(product, precinct, statsScope, period)

    return {
      product,
      precinct,
      uiScope,
      scopedStudents: scopedData.students,
      ...stats,
    }
  }

  makeStatsRequests = async (
    product: LegacyProductRex,
    precinct: LegacyPrecinctSpelling,
    scope: StudentsScope,
    period: NormalizedInterval,
  ) => {
    const { studentEvents } = this
    return RSVP.hash({
      spellingProgressTotals: studentEvents.courseProgressTotals(product, precinct, scope, period),
      spellingProgressAverages: studentEvents.courseProgressAverages(product, precinct, scope, period),
      spellingProgressHistory: studentEvents.courseProgressSpellingHistory(product, scope, period),
    })
  }
}

export default CourseProgressRexSpellingRoute
